import addToCart from "./add-to-cart";
import topSection from "./top-section";
import productAccordion from "./product-page-accordion";
import productCarousels from "./product-page-carousels";
import productStats from "./product-stats";
import deliveryEstimate from "./delivery-estimate";

document.addEventListener('DOMContentLoaded', () => {
  addToCart();
  // topSection();
  productAccordion();
  productCarousels();
  productStats();
  deliveryEstimate();
});